import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import Venster from '../Venster.jsx';

/**
 * Het leaderbord, als venster op het bureaublad.
 *
 * Het was een schermvullende laag met een donkere achtergrond: dan dekt het de
 * taakbalk af en kan er niets anders naast open staan. Nu kun je het naast je doek
 * laten hangen, en staat er een balkje voor in de taakbalk. Het kader, de titelbalk,
 * het kruisje en het slepen komen uit views/Venster.jsx.
 */
export default function Activity({ v }) {
  if (!v.showActivity) return null;
  return (
    <Venster v={v} venster={v.lbVenster} titel="Leaderbord" onSluit={v.closeActivity}>
      <div style={css(v.lbPanelStyle)}>
          {' '}
          <div style={css(v.lbColumnsStyle)}>
            {' '}
            <div style={{ "display": "flex", "flexDirection": "column", "gap": "10px", "minWidth": "0" }}>
              <div style={{ "fontSize": "11px", "fontWeight": "700", "letterSpacing": ".05em", "textTransform": "uppercase", "color": "var(--tekst-3)" }}>
                Dagen op rij
              </div>
              {toList(v.lbStreak).map((l, $index) => (
                <React.Fragment key={$index}>
                  <button onClick={l?.onClick} className="gp-btn" title={l?.title} style={{ "display": "flex", "alignItems": "center", "gap": "9px", "borderRadius": "12px", "padding": "8px 10px", "minWidth": "0", "width": "100%", "textAlign": "left" }}>
                    <span style={{ "fontSize": "17px", "flex": "0 0 auto" }}>
                      <Interp v={l?.medal} />
                    </span>
                    <img alt="" src={l?.avatarUrl} style={{ "width": "28px", "height": "28px", "imageRendering": "pixelated", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
                    <span style={{ "display": "flex", "flexDirection": "column", "minWidth": "0", "gap": "1px" }}>
                      <span style={{ "fontSize": "13px", "fontWeight": "700", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>
                        <Interp v={l?.name} />
                      </span>
                      <span style={{ "fontSize": "11px", "fontWeight": "600", "color": "var(--tekst-2)" }}>
                        <Interp v={l?.value} />
                      </span>
                    </span>
                  </button>
                </React.Fragment>
              ))}
            </div>
            {' '}
            <div style={{ "display": "flex", "flexDirection": "column", "gap": "10px", "minWidth": "0" }}>
              <div style={{ "fontSize": "11px", "fontWeight": "700", "letterSpacing": ".05em", "textTransform": "uppercase", "color": "var(--tekst-3)" }}>
                Meeste krabbels
              </div>
              {toList(v.lbDrawings).map((l, $index) => (
                <React.Fragment key={$index}>
                  <button onClick={l?.onClick} className="gp-btn" title={l?.title} style={{ "display": "flex", "alignItems": "center", "gap": "9px", "borderRadius": "12px", "padding": "8px 10px", "minWidth": "0", "width": "100%", "textAlign": "left" }}>
                    <span style={{ "fontSize": "17px", "flex": "0 0 auto" }}>
                      <Interp v={l?.medal} />
                    </span>
                    <img alt="" src={l?.avatarUrl} style={{ "width": "28px", "height": "28px", "imageRendering": "pixelated", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
                    <span style={{ "display": "flex", "flexDirection": "column", "minWidth": "0", "gap": "1px" }}>
                      <span style={{ "fontSize": "13px", "fontWeight": "700", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>
                        <Interp v={l?.name} />
                      </span>
                      <span style={{ "fontSize": "11px", "fontWeight": "600", "color": "var(--tekst-2)" }}>
                        <Interp v={l?.value} />
                      </span>
                    </span>
                  </button>
                </React.Fragment>
              ))}
            </div>
            {' '}
            <div style={{ "display": "flex", "flexDirection": "column", "gap": "10px", "minWidth": "0" }}>
              <div style={{ "fontSize": "11px", "fontWeight": "700", "letterSpacing": ".05em", "textTransform": "uppercase", "color": "var(--tekst-3)" }}>
                Meeste hartjes
              </div>
              {toList(v.lbLikes).map((l, $index) => (
                <React.Fragment key={$index}>
                  <button onClick={l?.onClick} className="gp-btn" title={l?.title} style={{ "display": "flex", "alignItems": "center", "gap": "9px", "borderRadius": "12px", "padding": "8px 10px", "minWidth": "0", "width": "100%", "textAlign": "left" }}>
                    <span style={{ "fontSize": "17px", "flex": "0 0 auto" }}>
                      <Interp v={l?.medal} />
                    </span>
                    <img alt="" src={l?.avatarUrl} style={{ "width": "28px", "height": "28px", "imageRendering": "pixelated", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
                    <span style={{ "display": "flex", "flexDirection": "column", "minWidth": "0", "gap": "1px" }}>
                      <span style={{ "fontSize": "13px", "fontWeight": "700", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>
                        <Interp v={l?.name} />
                      </span>
                      <span style={{ "fontSize": "11px", "fontWeight": "600", "color": "var(--tekst-2)" }}>
                        <Interp v={l?.value} />
                      </span>
                    </span>
                  </button>
                </React.Fragment>
              ))}
            </div>
            {' '}
            <div style={{ "display": "flex", "flexDirection": "column", "gap": "10px", "minWidth": "0" }}>
              <div style={{ "fontSize": "11px", "fontWeight": "700", "letterSpacing": ".05em", "textTransform": "uppercase", "color": "var(--tekst-3)" }}>
                Verzoekjes getekend
              </div>
              {toList(v.lbRequests).map((l, $index) => (
                <React.Fragment key={$index}>
                  <button onClick={l?.onClick} className="gp-btn" title={l?.title} style={{ "display": "flex", "alignItems": "center", "gap": "9px", "borderRadius": "12px", "padding": "8px 10px", "minWidth": "0", "width": "100%", "textAlign": "left" }}>
                    <span style={{ "fontSize": "17px", "flex": "0 0 auto" }}>
                      <Interp v={l?.medal} />
                    </span>
                    <img alt="" src={l?.avatarUrl} style={{ "width": "28px", "height": "28px", "imageRendering": "pixelated", "border": "2px solid var(--ink)", "borderRadius": "8px", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
                    <span style={{ "display": "flex", "flexDirection": "column", "minWidth": "0", "gap": "1px" }}>
                      <span style={{ "fontSize": "13px", "fontWeight": "700", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>
                        <Interp v={l?.name} />
                      </span>
                      <span style={{ "fontSize": "11px", "fontWeight": "600", "color": "var(--tekst-2)" }}>
                        <Interp v={l?.value} />
                      </span>
                    </span>
                  </button>
                </React.Fragment>
              ))}
            </div>
            {' '}
          </div>
          {' '}
      </div>
    </Venster>
  );
}
